export default {
	title: null,
	description: null,
	tagline: null,
	isVisible: true,
};
